import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { priceGetFormattedPrice } from '../../../../../../price'
import { useProductPageContext } from '../../../../productPageContext'
import { useProductPrices } from '../../../hooks/useProductPrices'

export const ProductBuyBoxStickyMobilePrice: FC<{ product: PimProductV11 }> = ({
  product,
}) => {
  const intl = useIntl()
  const { currentPrescriptionType, offerId } = useProductPageContext()
  const { displayPrice } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })

  return (
    <div className="flex flex-col items-start whitespace-nowrap">
      <span className="text-xs text-dark-primary-strong">
        <FormattedMessage id="general.label.yourPrice" />
      </span>
      <span className="font-bold text-dark-brand">
        {priceGetFormattedPrice(displayPrice?.price ?? 0, intl)}
      </span>
    </div>
  )
}
